module.exports = __webpack_public_path__ + "static/media/battery.48987651.svg";